import { Popover, Stack, Text } from "@mantine/core"
import { useClickOutside, useWindowScroll } from "@mantine/hooks"
import { Button } from "@tfg/ui"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"

interface Props {
  target: React.ReactNode
  onClick: () => void
  opened: boolean
  close: () => void
}

export const CertificateRequestBatchPopover = ({
  target,
  onClick,
  opened,
  close,
}: Props) => {
  const ref = useClickOutside(() => close())
  const { t } = useTranslation(["traceability"])
  const [scroll] = useWindowScroll()
  useEffect(() => {
    close()
  }, [scroll, close])
  return (
    <Popover
      width={200}
      opened={opened}
      withArrow
      position="top"
      offset={0}
      arrowOffset={0}
    >
      <Popover.Target>{target}</Popover.Target>
      <Popover.Dropdown>
        <Stack ref={ref}>
          <Text size="xs">
            {t("traceability:batchPopover.certificateText")}
          </Text>
          <Button onClick={onClick} size="xs">
            {t("traceability:batchPopover.button")}
          </Button>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  )
}
